// local columns
import categoryColumn from '../columns/category.column';
import dateColumn from '../columns/date.column';
import urlColumn from '../columns/url.column';

const generateColumns = () => [urlColumn, categoryColumn, dateColumn];

export default generateColumns;
